import { Injectable, NgZone } from "@angular/core";
import { NgModel, NgForm } from '@angular/forms';
import { Router } from "@angular/router";
import { ConfirmationService } from "@systemic/ng-confirmations";
import { AlertsService } from "@jaspero/ng-alerts";
import { NotificationsService } from "angular2-notifications";
import { CookieService } from "ngx-cookie";
import { HttpService } from "../http/http.service";

import { CookiesGuru, ScriptGuru, NotifyGuru, RegexGuru, DateTimeGuru, PrimeNgGuru } from "../../helper";
import { MlToken, MlUser, MlBranch, MlCompany, MlApiServer, MlAuthServer, MlProvider, requestType } from "../../interface";
import * as $ from 'jquery';
import { Title } from "@angular/platform-browser";
import { HttpErrorResponse } from "@angular/common/http";
import { ErrorLogService } from "../error/error.service";
import { RouterExtService } from "../router/router-ext.service";
import { AuthService } from "@service/auth/auth.service";
import { Observable } from "rxjs/Observable";
import { PageRoleRights, PageAction } from "@service/auth/auth.modal";
import * as Moment from 'moment';

@Injectable()
export class UtilitesService {
  public PageAccess: PageAction[];
  public http: HttpService;
  public routerExt: RouterExtService;
  public notify: NotifyGuru;
  public cookie: CookiesGuru;
  public router: Router;
  public zone: NgZone;
  public moment = Moment;
  public dtGuru = DateTimeGuru;
  public errorService: ErrorLogService;
  public script: ScriptGuru;
  public regex = RegexGuru;
  public defaultImage = DefaultImage;
  public primeNg = PrimeNgGuru;
  private units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  private maxFileUploadSizeInBytes = 6291456;
  constructor(_http: HttpService,
    _srvConfirm: ConfirmationService,
    _errorService: ErrorLogService,
    _srvAlert: AlertsService,
    _srvNoty: NotificationsService,
    _routerExt: RouterExtService,
    _router: Router,
    _cookie: CookieService,
    _zone: NgZone,
    titleService: Title) {
    this.http = _http;
    this.router = _router;
    this.notify = new NotifyGuru(_srvConfirm, _srvAlert, _srvNoty);
    this.cookie = new CookiesGuru(_cookie);
    this.script = new ScriptGuru(titleService);
    this.zone = _zone;
    this.zone = _zone;
    this.errorService = _errorService;
    this.routerExt = _routerExt;
  }

  public isValidSelectedValue(val: number | string): boolean {
    return (typeof val !== 'undefined' && val !== NaN && val !== null && val !== '' && val !== '0' && val !== 0);
  }
  public isValidModel(val: any): boolean {
    return (typeof val !== 'undefined' && val !== NaN && val !== null && typeof val === 'object');
  }
  public isNullOrUndefined(val: any): boolean {
    return (typeof val === 'undefined' && val !== NaN || val === null);
  }
  public isValidObject(val: any): boolean {
    return (val !== undefined && val !== NaN && val !== null);
  }
  public isEmpty(val: any): boolean {
    if (val === undefined || val === NaN || val === null) {
      return true;
    } else if (val === 'undefined') {
      return true;
    } else if (val.length <= 0) {
      return true;
    } else {
      return false;
    }
  }
  public isValidList(val: any[]): boolean {
    if (typeof val === 'undefined' || val === null) {
      return false;
    } else if (val.length === 0) {
      return false;
    } else {
      return true;
    }
  }
  public isCtrlValid(Ctrl: NgModel, Form: NgForm) {
    return (Ctrl.errors && Form.submitted);
  }
  public isValidFileSize(bytes: number): boolean {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      return false;
    } else {
      return bytes < this.maxFileUploadSizeInBytes;
    }
  }
  public bytesToSize(bytes: number = 0, precision: number = 2): string {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) { return '?'; }

    let unit = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }
    return bytes.toFixed(+ precision) + ' ' + this.units[unit];
  }
  public get TokenContext(): MlToken {
    const appConfig = new MlToken();
    appConfig.UserInfo = this.cookie.get<MlUser>('Config.UserInfo');
    appConfig.BranchInfo = this.cookie.get<MlBranch>('Config.BranchInfo');
    appConfig.CompanyInfo = this.cookie.get<MlCompany>('Config.CompanyInfo');
    appConfig.ApiServer = this.cookie.get<MlApiServer>('Config.ApiServer');
    appConfig.AuthServer = this.cookie.get<MlAuthServer>('Config.AuthServer');
    appConfig.Provider = this.cookie.get<MlProvider>('Config.Provider');
    if (!this.isValidModel(appConfig) &&
      !this.isValidModel(appConfig.UserInfo) &&
      !this.isValidModel(appConfig.BranchInfo) &&
      !this.isValidModel(appConfig.CompanyInfo) &&
      !this.isValidModel(appConfig.ApiServer) &&
      !this.isValidModel(appConfig.AuthServer) &&
      !this.isValidModel(appConfig.Provider)) {
      throw new Error('user context is not valid');
    }
    return appConfig;
  }
  public authUrl(url: string): string {
    if (this.TokenContext && this.TokenContext.AuthServer) {
      return this.TokenContext.AuthServer.Url + url;
    } else {
      return '';
    }
  }
  public apiUrl(url: string): string {
    if (this.TokenContext && this.TokenContext.ApiServer) {
      return this.TokenContext.ApiServer.Url + url;
    } else {
      return '';
    }
  }
  public imageUrl(url: string) {
    if (this.TokenContext && this.TokenContext.ApiServer) {
      return this.TokenContext.ApiServer.Url + url;
    } else {
      return url;
    }
  }
  public printUrl(url: string) {
    if (this.TokenContext && this.TokenContext.ApiServer) {
      return this.TokenContext.ApiServer.Url + url;
    } else {
      return url;
    }
  }
  public assign<T>(source: T): T {
    return JSON.parse(JSON.stringify(source));
  }
  public maxFileSize() {
    return this.bytesToSize(this.maxFileUploadSizeInBytes);
  }

  public isActionAllowed(Action: string): boolean {
    if (this.PageAccess !== undefined) {
      return (this.PageAccess.filter((x: any) => x.Name === Action).length > 0);
    } else {
      return false;
    }
  }
  Check_Page_Rights(Route: string): Observable<PageRoleRights> {
    const ReqPath = `/web/auth/check-page-rights?URL=${Route}`;
    return this.http.get<PageRoleRights>(ReqPath, {
      RequestType: requestType.Protected
    }).map(res => {
      return res.result;
    }
    )
      .catch(e => {
        return Observable.throw(false);
      });
  }
  public LoadPageAction(func?: Function) {
    const Route = this.router.url.replace('/app/', '')
    this.Check_Page_Rights(Route).subscribe(data => {
      if (data.IsAllowPage) {
        if (this.isValidList(data.Actions)) {
          this.PageAccess = data.Actions;
          if (func !== undefined) {
            func(this.PageAccess);
          }
        }
      } else {
        this.cookie.remove('Config.UserInfo');
        this.cookie.remove('Config.BranchInfo');
        this.cookie.remove('Config.CompanyInfo');

        const apiserver = this.TokenContext.ApiServer;
        const authserver = this.TokenContext.AuthServer;
        apiserver.ApiKey = '';
        apiserver.IsTokenReady = false;
        authserver.AuthKey = '';
        authserver.Url = '';
        authserver.ProjectKey = '';
        this.cookie.set('Config.ApiServer', apiserver);
        this.cookie.set('Config.AuthServer', authserver);
        this.router.navigate(['/auth/login']);
      }
    });
  }
  CheckAction(ActionName: string): boolean {
    return true;
  }
  fileSize(bytes: number = 0, precision: number = 2): string {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) { return '?'; }

    let unit = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }
    return bytes.toFixed(+ precision) + ' ' + this.units[unit];
  }
}
class DefaultImage {
  static Mobile_Logo = '/app-data/company/default/app-logo.jpg';
  static Mobile_Splash = '/app-data/company/default/app-splash.jpg';
  static Company_Logo = 'MobileLogoImgSrc';
  static Category_Offer_List = '/app-data/company/default/category-offer.jpg';
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/services/utilities/utilities.service.ts